import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const FiltersTriggerButton = props => {
  const { className, filtersCount, iconClassName, onClick } = props;

  const iconButtonClassName = classnames('icon-filter', iconClassName);

  return (
    <button type="button" className={className} onClick={onClick}>
      <span className={iconButtonClassName} />

      {filtersCount > 0 && <span className="ml-1">{filtersCount}</span>}
    </button>
  );
};

FiltersTriggerButton.propTypes = {
  className: PropTypes.string,
  filtersCount: PropTypes.number,
  iconClassName: PropTypes.string,
  onClick: PropTypes.func,
};

FiltersTriggerButton.defaultProps = {
  className: '',
  filtersCount: 0,
  iconClassName: '',
  onClick: () => {},
};

export default FiltersTriggerButton;
